export default "__VITE_ASSET__CRtgCpml__"